// Search toggle type constants
export const UNPAID = 'UNPAID'
export const CIVIL_RECOVERY = 'CIVIL_RECOVERY'
export const DRIVE_OFF = 'DRIVE_OFF'
export const GONE_TO_CIVIL_RECOVERY = 'Gone to Civil Recovery'

export type SearchToggleType =
  | typeof UNPAID
  | typeof CIVIL_RECOVERY
  | typeof DRIVE_OFF

export interface IToggleButton {
  label: string
  value: string
}

export interface ISearchToggleState {
  activeToggle: string
  unpaidCount: number
  civilRecoveryCount: number
}
